import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
var TimeRequestDialogComponent = /** @class */ (function () {
    function TimeRequestDialogComponent(dialogRef, data, fb) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fb = fb;
        this.title = data.TitleText || 'Request Time Approval';
        this.message = data.MessageText || '';
        this.inputprefix = data.InputPrefix || '';
        this.inputhint = data.InputHint || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.timeeditable = data.TimeEditable != null ? data.TimeEditable : true;
        this.validators = data.Validators || null;
        this.value = data.Value != null ? data.Value : null;
        this.textboxprefix = data.TextboxPrefix || '';
    }
    TimeRequestDialogComponent.prototype.ngOnInit = function () {
        // Set up the form group
        this.inputForm = this.fb.group({
            JobTime: [this.value],
            OptionalComment: [''],
        });
        // If we were provided validators, set them now.
        if (this.validators && this.validators.length > 0) {
            var ctrl = this.inputForm.get('JobTime');
            var toSet = [Validators.required].concat(this.validators);
            ctrl.setValidators(toSet);
            this.inputForm.updateValueAndValidity();
        }
    };
    TimeRequestDialogComponent.prototype.CancelHandler = function () {
        this.dialogRef.close(null);
    };
    TimeRequestDialogComponent.prototype.OKHandler = function () {
        var response = this.inputForm.getRawValue();
        this.dialogRef.close(response);
    };
    return TimeRequestDialogComponent;
}());
export { TimeRequestDialogComponent };
// #region Custom Classes
var BaseTimeRequestDialogOptions = /** @class */ (function () {
    function BaseTimeRequestDialogOptions() {
    }
    return BaseTimeRequestDialogOptions;
}());
export { BaseTimeRequestDialogOptions };
// #region Base Time Request Result Class
var BaseTimeRequestResult = /** @class */ (function () {
    function BaseTimeRequestResult() {
    }
    return BaseTimeRequestResult;
}());
export { BaseTimeRequestResult };
// #endregion
// #endregion
